import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
   name: 'renderHtmlString',
   standalone: true
})
export class RenderHtmlStringPipe implements PipeTransform {
   constructor(private sanitizer: DomSanitizer) {}

   transform(value: string): SafeHtml {
      return this.sanitizer.bypassSecurityTrustHtml(
         value.replace(/\r\n|\r|\n/g, '<br />')
      );
   }
}
